import React from "react"
import { View, Radio, Text } from "react-ame-components"
import Showcase from "../components/Showcase"

export class RadioExample extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      texto: "texto",
      valueRadioSelected: "",
    }
  }

  setTexto = texto => {
    this.setState({ texto })
  }

  selectValue = value => {
    this.setState({
      valueRadioSelected: value,
    })
  }

  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Radio"
        description="Este componente serve para exibir um seletor de opções.">
        <View
          marginBottom="large"
          direction="row"
          width="100px"
          align="center">
          <Radio
            value="texto 1"
            name="teste"
            onChange={e => {
              this.setTexto(e)
              this.selectValue(e)
            }}
            checked={this.state.valueRadioSelected}
          />
          <Text
            textAlign="center"
            target="description">
            Teste 1
          </Text>
        </View>
        <View
          marginBottom="large"
          direction="row"
          width="100px">
          <Radio
            value="texto 2"
            name="teste"
            onChange={e => {
              this.setTexto(e)
              this.selectValue(e)
            }}
            checked={this.state.valueRadioSelected}
          />
          <Text
            textAlign="center"
            target="description">
            Teste 2
          </Text>
        </View>
        <View
          marginBottom="large"
          direction="row"
          width="100px">
          <Radio
            value="texto 3"
            name="teste"
            onChange={e => {
              this.setTexto(e)
              this.selectValue(e)
            }}
            checked={this.state.valueRadioSelected}
          />
          <Text
            textAlign="center"
            target="description">
            Teste 3
          </Text>
        </View>
      </Showcase>
    )
  }
}
